import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Modal,
  notification,
  Form,
  Input,
} from "antd";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import urldata from "../../../../urldata";

function InternationalReachDynamic() {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [btnSize, setBtnSize] = useState("middle");

  const base_api = urldata + "admin/";
  const getEndpoint = base_api + "getInternationalReach";
  const addEndpoint = base_api + "addInternationalReach";
  const updateEndpoint = base_api + "updateInternationalReach";

  // Adjust button size on mobile
  useEffect(() => {
    setBtnSize(isMobile ? "small" : "middle");
  }, [isMobile]);

  // Fetch data
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(getEndpoint);
      const section = response?.data?.data?.[0]; // Always take first item
      if (section) {
        setData(section);
        form.setFieldsValue({
          title: section.title,
          description: section.description,
        });
      } else {
        setData(null);
        form.resetFields();
      }
    } catch (err) {
      console.error(err);
      notification.error({ message: "Failed to fetch data" });
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle submit (add or update)
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      let response;
      if (data) {
        // Update existing — ID in query string
        response = await axios.post(`${updateEndpoint}?id=${data._id}`, values);
      } else {
        // Add new
        response = await axios.post(addEndpoint, values);
      }

      const message = response?.data?.message || "";
      const section = response?.data?.data?.[0]; // Always take first element

      if (
        message.includes("updated successfully") ||
        message.includes("added successfully")
      ) {
        notification.success({ message: "Saved Successfully" });

        // Update state so UI reflects new data
        if (section) {
          setData(section);
          form.setFieldsValue({
            title: section.title,
            description: section.description,
          });
        }

        setModalVisible(false); // close modal
      } else {
        notification.error({ message: message || "Operation failed" });
      }
    } catch (err) {
      console.error(err);
      notification.error({ message: "Something went wrong" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>International Reach</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <Card title="International Reach" bordered={false}>
            <Row style={{ marginBottom: 20 }}>
              <Col span={24}>
                <Space
                  direction="vertical"
                  size="middle"
                  style={{ width: "100%" }}
                >
                  {/* Display current data with indicators */}
                  {data ? (
                    <div
                      style={{
                        padding: "10px",
                        background: "#fafafa",
                        borderRadius: 4,
                      }}
                    >
                      <div style={{ marginBottom: 10 }}>
                        <strong>Title:</strong>
                        <div style={{ padding: "5px 0", color: "#555" }}>
                          {data.title}
                        </div>
                      </div>
                      <div>
                        <strong>Description:</strong>
                        <div style={{ padding: "5px 0", color: "#555" }}>
                          {data.description}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p style={{ fontStyle: "italic", color: "#888" }}>
                      No data available. Please add International Reach info.
                    </p>
                  )}

                  {/* Button to add/edit */}
                  <Button
                    type="primary"
                    size={btnSize}
                    onClick={() => setModalVisible(true)}
                  >
                    {data
                      ? "Edit International Reach"
                      : "Add International Reach"}
                  </Button>
                </Space>
              </Col>
            </Row>

            {/* Modal remains unchanged */}
            <Modal
              title={
                data ? "Edit International Reach" : "Add International Reach"
              }
              visible={modalVisible}
              onCancel={() => setModalVisible(false)}
              okText="Submit"
              confirmLoading={loading}
              onOk={() => {
                form
                  .validateFields()
                  .then(handleSubmit)
                  .catch(() => {});
              }}
              width={700}
            >
              <Form layout="vertical" form={form}>
                <Row gutter={16}>
                  <Col xs={24}>
                    <Form.Item
                      label="Title"
                      name="title"
                      extra="Recommended character limit: 40"
                      rules={[
                        { required: true, message: "Title is required" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                      <div className="fileTxt">Use &lt;br /&gt; tag for line break.</div>
                  </Col>

                  <Col xs={24}>
                    <Form.Item
                      label="Description"
                      name="description"
                      extra="Recommended character limit: 350"
                      rules={[
                        { required: true, message: "Description is required" },
                      ]}
                    >
                      <Input.TextArea rows={5} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Modal>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default InternationalReachDynamic;
